/**
 * Single source of truth for "does the patient-matching step already have a
 * deterministic, ready-to-accept match?".
 *
 * A match is auto-acceptable when the system pre-selected the first candidate
 * (`selected_match_index === 0`) and the reviewer has not yet given any
 * feedback on it (`!feedback_status`). This is the same condition that drives
 * the "Claim ID match found!" auto-accept dialog on the patient-matching page.
 *
 * Returns the index to auto-accept, or `null` when the step is not
 * deterministically matched and must be reviewed manually.
 *
 * NOTE (PBDP-1412): this is an interim frontend-only signal. The authoritative
 * determinism signal is the backend `system_match_method`
 * (`claim_id` / `carrier_claim_id_full` / `carrier_claim_id_partial`), which is
 * not yet exposed on the claim patient-matches response. When it is, swap the
 * body of this helper — both the auto-accept dialog and the skip-matching flow
 * consume it, so they update together.
 */
export function getAutoAcceptPatientMatchIndex({
  selectedMatchIndex,
  feedbackStatus,
}: {
  selectedMatchIndex: number | null | undefined
  feedbackStatus: string | null | undefined
}): number | null {
  if (selectedMatchIndex === 0 && !feedbackStatus) {
    return selectedMatchIndex
  }
  return null
}
